import { STORE_GET_SETUP_REQUEST_START, STORE_GET_SETUP_REQUEST_ERROR, STORE_GET_SETUP_REQUEST_SUCCESS, STORE_SELECT, STORE_SET_IS_OPENED } from "../actions/store";

const defaultStoreObject = {
    storeId: null,
    storeName: '',
    maxOnlinePartySize: 0,
    onlinePartySizeDefault: 0,
    minOnlinePartySize: 0,
    termsAndCondition: null,
    services: {
        lunch: null,
        dinner: null,
    },
    maxBookingDaysInAdvance: 0,
    lunchTimes: null,
    dinnerTimes: null,
    isFetching: false,
    hasError: false,
    termsAndConditionsTranslation: '',
}

const defaultState = {
    storeIdSelected: null,
    stores: {

    }
};

export const storeReducer = (state = defaultState, action) => {
    switch (action.type) {
        case STORE_SELECT: {
            return { ...state, storeIdSelected: action.storeId }
        }
        case STORE_GET_SETUP_REQUEST_START: {
            return {
                ...state,
                stores: {
                    ...state.stores,
                    [action.storeId]: {
                        ...defaultStoreObject,
                        isFetching: true
                    }
                }
            }
        }
        case STORE_GET_SETUP_REQUEST_ERROR: {
            return {
                ...state,
                stores: {
                    ...state.stores,
                    [action.storeId]: {
                        ...defaultStoreObject,
                        hasError: true
                    }
                }
            }
        }
        case STORE_SET_IS_OPENED: {
            return {
                ...state,
                stores: {
                    ...state.stores,
                    [action.storeId]: {
                        ...defaultStoreObject,
                        isOpened: false,
                    }
                }
            }
        }
        case STORE_GET_SETUP_REQUEST_SUCCESS: {
            return {
                ...state,
                stores: {
                    ...state.stores,
                    [action.storeId]: {
                        storeId: action.storeId,
                        storeName: action.storeName,
                        maxOnlinePartySize: action.maxOnlinePartySize,
                        termsAndConditions: action.termsAndConditions,
                        services: action.services,
                        lunchTimes: action.lunchTimes,
                        dinnerTimes: action.dinnerTimes,
                        maxBookingDaysInAdvance: action.maxBookingDaysInAdvance,
                        termsAndConditionsTranslation: action.termsAndConditionsTranslation,
                        onlinePartySizeDefault: action.onlinePartySizeDefault,
                        minOnlinePartySize: action.minOnlinePartySize,
                        logo: action.logo,
                        popupDetails: action.popupDetails,
                        showPopup: action.showPopup,
                        availabilityTranslations: action.availabilityTranslations,
                        phone: action.phone,
                        isFetching: false,
                        hasError: false,
                    }
                }
            }
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/store.js